import { useEffect, useState } from "react";
import { api, fmtDate, fmtEur, formatErr, CATEGORIE_LABELS } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";
import { Link2, Check } from "lucide-react";
import { toast } from "sonner";

export const RiconciliazionePanel = ({ company, pMap, writable, onChange }) => {
  const [items, setItems] = useState(null);
  const load = () => api.get("/riconciliazione", { params: { company } }).then((r) => setItems(r.data));
  useEffect(() => { load(); }, [company]); // eslint-disable-line
  const conferma = async (m, b) => {
    try {
      await api.post("/riconciliazione/conferma", { manuale_id: m.id, movimento_id: b?.id || null });
      toast.success(b ? "Abbinato al movimento di banca" : "Riga confermata");
      load(); onChange();
    } catch (e) { toast.error(formatErr(e.response?.data?.detail)); }
  };
  if (!items) return <div className="text-sm text-muted-foreground p-4">Caricamento…</div>;
  if (items.length === 0) return <Card className="p-6 text-center text-sm text-muted-foreground" data-testid="ric-empty">Nessuna riga del conteggio da riconciliare</Card>;
  return (
    <div className="space-y-3" data-testid="ric-panel">
      {items.map((m) => (
        <Card key={m.id} className="p-3 rounded-md" data-testid={`ric-item-${m.id}`}>
          <div className="flex items-center justify-between flex-wrap gap-2">
            <div className="text-sm">
              <Badge className="bg-orange-500 h-5 mr-2">Dal conteggio</Badge>
              <span className="font-mono text-xs mr-2">{fmtDate(m.data)}</span>
              <b>{pMap[m.padroncino_id] || "—"}</b> · {m.descrizione} · <span className="text-muted-foreground">{CATEGORIE_LABELS[m.categoria]}</span>
            </div>
            <div className="flex items-center gap-2">
              <span className={`font-mono font-bold ${m.tipo === "entrata" ? "text-green-600" : "text-destructive"}`}>{m.tipo === "entrata" ? "+" : "-"}{fmtEur(m.importo)}</span>
              {writable && <Button size="sm" variant="outline" className="h-7 gap-1" onClick={() => conferma(m)} data-testid={`ric-conferma-${m.id}`}><Check className="w-3.5 h-3.5" />Conferma senza abbinare</Button>}
            </div>
          </div>
          {m.candidati.length === 0
            ? <div className="text-xs text-muted-foreground mt-2">Nessun movimento di banca corrispondente (stesso importo, entro 30 giorni) per ora.</div>
            : <table className="autotrans-table w-full text-xs mt-2">
                <thead><tr><th>Possibile corrispondenza in banca</th><th>Data</th><th>Banca</th><th className="text-right">Importo</th><th></th></tr></thead>
                <tbody>{m.candidati.map((b) => (
                  <tr key={b.id} data-testid={`ric-cand-${b.id}`}>
                    <td>{b.descrizione}{b.stesso_padroncino && <Badge variant="outline" className="ml-2 h-4 text-[10px]">stesso padroncino</Badge>}</td>
                    <td className="font-mono">{fmtDate(b.data)} <span className="text-muted-foreground">({b.giorni}gg)</span></td>
                    <td>{b.banca || "—"}</td>
                    <td className="text-right font-mono">{fmtEur(b.importo)}</td>
                    <td className="text-right">{writable && <Button size="sm" className="h-6 gap-1" onClick={() => conferma(m, b)} data-testid={`ric-abbina-${m.id}-${b.id}`}><Link2 className="w-3 h-3" />Abbina e conferma</Button>}</td>
                  </tr>))}
                </tbody>
              </table>}
        </Card>
      ))}
    </div>
  );
};
